<!--<c-footer>-->
  <div>
    <a href="https://ringoffice.com" target="_blank">RingOffice</a>
    <span> &copy; 2025 Version: 1.0.0.1</span>
  </div>
  <div class="ms-auto">
    Powered by
    <a href="https://ringoffice.com" target="_blank">
      <span>RingOffice</span>
    </a>
  </div>
<!--</c-footer>-->
